<div class="container-fluid contentHeight noPrint form">
  <div class="tab-content" id="nav-tabContent">
    <h1 class="titleHisto">{{ 'contretypage.titleHistoric' | translate}}</h1>
    <div class="content backgroundWhiteRound">
      <div class="beforeTable">
        <fieldset class="noMargin row fieldset">
          <legend class="legend">{{ 'monitoring.search' | translate }} </legend>
          <div class="filter">
            <form [formGroup]="filterForm">
              <mat-form-field>
                <mat-label>{{ 'contretypage.num' | translate}}</mat-label>
                <input matInput formControlName="filterColorMatchingID" type="text" id="numberColorMatching" value="">
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'contretypage.status' | translate}}</mat-label>
                <mat-select multiple formControlName="filterStatus">
                  <mat-option id="statusColorMatching" *ngFor="let key of keys" [value]="key">{{ 'contretypage.'+StatusCMType[key] | translate}}</mat-option>
                </mat-select>
              </mat-form-field>

              <!--<mat-form-field class="datePicker">
                <input matInput [matDatepicker]="startdp" [min]="datemin" [max]="datenow" [formControl]="startdate" disabled>
                <mat-datepicker-toggle matSuffix [for]="startdp"></mat-datepicker-toggle>
                <mat-datepicker #startdp
                                disabled="false"
                                startView="multi-year"
                                (yearSelected)="chosenStartYearHandler($event)"
                                (monthSelected)="chosenStartMonthHandler($event, startdp)"
                                panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>

              <mat-form-field class="datePicker">
                <input matInput [matDatepicker]="enddp" [min]="datemin" [max]="datenow" [formControl]="enddate" disabled>
                <mat-datepicker-toggle matSuffix [for]="enddp"></mat-datepicker-toggle>
                <mat-datepicker #enddp
                                disabled="false"
                                startView="multi-year"
                                (yearSelected)="chosenEndYearHandler($event)"
                                (monthSelected)="chosenEndMonthHandler($event, enddp)"
                                panelClass="example-month-picker">
                </mat-datepicker>
              </mat-form-field>-->
              <button class="btn btnRecherche" (click)="changeFilter()">{{ 'accountChoice.rechercher' | translate }}</button>
            </form>
          </div>
        </fieldset>
      </div>
      <div class="tab-pane noOverflow fade show active">
        <mat-table class="table lstContretypage bg-white table-hover" [dataSource]="colorMatchingSource" matSort>
          <!--(matSortChange)="sortFile($event,'1')">-->
          <!-- N° de demande Column -->
          <ng-container matColumnDef="reference">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contretypage.num' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.reference | uppercase }} </mat-cell><!--{ element.colorMatchingID }}-->
          </ng-container>
          <!-- N° de demande Column -->
          <ng-container matColumnDef="numeroSuivi">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'rentinglist.numero' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.numeroSuivi | uppercase }} </mat-cell><!--{ element.colorMatchingID }}-->
          </ng-container>
          
          <!-- Etat de la demande Column -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'contretypage.status' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ 'contretypage.'+StatusColorMatchingType[element.status] | translate }} </mat-cell>
          </ng-container>

          <!-- date de creation de demande Column -->
          <ng-container matColumnDef="dateCreate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  {{ 'contretypage.creation' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.dateCreate | date:"dd/MM/yyyy" }} </mat-cell>
          </ng-container>

          <!-- Carrosserie Column -->
          <ng-container matColumnDef="socialReason">
            <mat-header-cell *matHeaderCellDef>  {{ 'contretypage.carrosserie' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.company_SocialReason }} </mat-cell>
          </ng-container>

          <!-- User Carrosserie Column -->
          <ng-container matColumnDef="client">
            <mat-header-cell *matHeaderCellDef>  {{ 'contretypage.client' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.user_Name }} {{  element.user_Firstname}} </mat-cell>
          </ng-container>

          <!-- CTC Column -->
          <ng-container matColumnDef="ctc">
            <mat-header-cell *matHeaderCellDef>  {{ 'contretypage.ctc' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.ctC_Name }} {{  element.ctC_Firstname}} </mat-cell>
          </ng-container>

          <!-- Marque du vehicule Column -->
          <ng-container matColumnDef="marque">
            <mat-header-cell *matHeaderCellDef>  {{ 'common.manufacturer' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.brandVehicle != ''; then showBrand else notShow"></span>
              <ng-template #showBrand>
                {{ element.brandVehicle }}
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Model de vehicule Column -->
          <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef>  {{ 'search.model' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.modelVehicle != ''; then showModel else notShow"></span>
              <ng-template #showModel>
                {{ element.modelVehicle }}
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Element a contretyper Column -->
          <ng-container matColumnDef="eltSend">
            <mat-header-cell *matHeaderCellDef>  {{ 'contretypage.titleEltContretype' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.designationOriginElement != ''; then showElement else notShow"></span>
              <ng-template #showElement>
                {{ element.designationOriginElement }}
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Date de Reception de l'element Column -->
          <ng-container matColumnDef="dateReceive">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  {{ 'contretypage.reception' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="compareDate(element.dateReceive); then showDate else elseif"></span>
              <ng-template #showDate>
                {{ element.dateReceive | date:"dd/MM/yyyy" }}
              </ng-template>
              <ng-template #elseif>
                <span *ngIf="Utils.isAxalta(role) && element.designationOriginElement != ''; then showBtn else notShow"></span>
              </ng-template>
              <ng-template #showBtn>
                <i  aria-hidden="true" class="far btnHisto fa-hand-receiving fa-1x5 pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" (click)="openModalReceive(element)" matTooltip="{{ 'contretypage.receptionMsg' | translate}}"></i>
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Date de Reponse Column -->
          <ng-container matColumnDef="dateFinish">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  {{ 'contretypage.reponse' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="compareDate(element.dateFinish); then showDate else notShow"></span>
              <ng-template #showDate> {{ element.dateFinish | date:"dd/MM/yyyy" }}</ng-template>
            </mat-cell>
          </ng-container>

          <!-- Btn Visualiser Column -->
          <ng-container matColumnDef="btnVisual">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
              <i  aria-hidden="true" class="fas btnHisto fa-search fa-1x5 pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" (click)="visualColorMatching(res)" matTooltip="{{ 'contretypage.visualiserMsg' | translate}}"></i>
            </mat-cell>
          </ng-container>

          <!-- Btn Print Column -->
          <ng-container matColumnDef="btnPrint">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
              <i  aria-hidden="true" class="fad btnHisto fa-print fa-1x5 pointer" style=" --fa-primary-color: #38383a ; --fa-secondary-color: #38383A;" (click)="print(res)" matTooltip="{{ 'contretypage.imprimerMsg' | translate}}"></i>
            </mat-cell>
          </ng-container>

          <!-- Btn validate Column -->
          <ng-container matColumnDef="btnValidate">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
              <span *ngIf="(res.status == 3 && res.published == 1); then showValiderContretypage else notShow"></span><!-- res = terminer (3) et en attente de publication (1) -->
              <ng-template #showValiderContretypage>
                <i  aria-hidden="true" class="fad btnHisto fa-file-check fa-1x5 pointer" style=" --fa-primary-color: #009236 ; --fa-secondary-color: #009236;" (click)="validerContretypage(res)" matTooltip="{{ 'contretypage.validerContretypage' | translate}}"></i>
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Btn copie Column -->
          <ng-container matColumnDef="btnCopie">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
              <span *ngIf="(res.status == 3) && (res.duplicated == 0); then showCopieContretypage else notShow"></span><!-- res = terminer (3) -->
              <ng-template #showCopieContretypage>
                <i  aria-hidden="true" class="fad btnHisto fa-copy fa-1x5 pointer" style=" --fa-primary-color: #009236 ; --fa-secondary-color: #009236;" (click)="copieContretypage(res)" matTooltip="{{ 'contretypage.copieContretypage' | translate}}"></i>
              </ng-template>
            </mat-cell>
          </ng-container>

          <!-- Btn export Column -->
          <ng-container matColumnDef="btnExport">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let res" [ngClass]="'customWidthButtonTable'">
              <span *ngIf="(res.status == 3); then showExportContretypage else notShow"></span><!-- res = terminer (3) et en attente de publication (1) -->
              <ng-template #showExportContretypage>
                <i  aria-hidden="true" *ngIf="Utils.isAxalta(role) && res.dateFinish != undefined" class="fad btnHisto fa-file-export fa-1x5 pointer" style=" --fa-primary-color: #E8641B ; --fa-secondary-color: #E8641B;" (click)="exportContretypage(res)" matTooltip="{{ 'contretypage.exportContretypage' | translate}}"></i>
              </ng-template>
            </mat-cell>
          </ng-container>



          <ng-template #notShow> - </ng-template>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
      </div>
    </div>
  </div>
</div>


<!-- Modal de confirmation validation contretypage -->
<div id="ModalConfirmContretypage" class="modal">
  <div class="modal-content-confirm">
    <span class="text-right mr-2 pointer close" (click)="closeModal('ModalConfirmContretypage');">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    <div class="container">
      <div class="upperText">
        <h2 class="text-center">{{'contretypage.contretypagePublier'|translate}}</h2>
      </div>
      <div class="center">
        <button class="btn btn-secondary modal-content-confirm-ok" type="button" name="Cancel" value="Cancel" (click)="closeModal('ModalConfirmContretypage')">
          <span [translate]="'contretypage.confirmer'"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de infirmation validation contretypage -->
<div id="ModalInfirmationContretypage" class="modal">
  <div class="modal-content-confirm">
    <span class="text-right mr-2 pointer close" (click)="closeModal('ModalInfirmationContretypage');">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    <div class="container">
      <div class="upperText">
        <h2 class="text-center">{{'contretypage.contretypageNonPublier'|translate}}</h2>
      </div>
      <div class="center">
        <button class="btn btn-secondary modal-content-confirm-ok" type="button" name="Cancel" value="Cancel" (click)="closeModal('ModalInfirmationContretypage')">
          <span [translate]="'contretypage.confirmer'"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de infirmation validation contretypage -->
<div id="ModalEnCoursContretypage" class="modal">
  <div class="modal-content-confirm">
    <!--<span class="text-right  mr-2" (click)="closeModal('ModalEnCoursContretypage');">  <i  aria-hidden="true" class=" fas fa-times fa-3x" style="cursor: pointer ; color: #e0003c;"></i> </span>-->
    <div class="container">
      <div class="upperText">
        <h2 class="text-center">{{'contretypage.contretypageEnCoursPublier'|translate}}</h2>
      </div>
      <div class="center">
        <i  aria-hidden="true" class="fad fa-spinner fa-pulse fa-3x" style=" --fa-primary-color: #009236 ; --fa-secondary-color: #009236;"></i>
        <!--<button class="btn btn-secondary modal-content-confirm-ok" type="button" name="Cancel" value="Cancel" (click)="closeModal('ModalEnCoursContretypage')">
          <span [translate]="'contretypage.confirmer'"></span>
        </button>-->
      </div>
    </div>
  </div>
</div>

<div id="ModalReceive" class="modal noPrint">
  <div class="modal-content">
    <div class="headerModal">
      <h3 class="leftFlex">{{ 'contretypage.titleReception' | translate}}</h3>
      <span class="rightFlex pointer close" (click)="closeModalReceive()">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    </div>
    <div>
      <div class="row">
        <div class="col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
          <p class="text-center" [translate]="''">{{ 'contretypage.contentReception' | translate}}</p>
        </div>
      </div>
      <div class="center">
        <button class="btn btn-secondary btnValid button" type="button" label="Annuler" name="Annuler" value="Annuler" (click)="closeModalReceive()">{{ 'assistance.non' | translate}}</button>
        <button class="btn btn-secondary btnValid button" type="submit" label="Enregistrer" (click)="addDateReceive(colMatching.colorMatchingID)">{{ 'assistance.oui' | translate}}</button>
      </div>
    </div>
  </div>
</div>


<div class="toPrint">

  <div class="headerPrint">
    <img class="enteteImp" src="assets/Impression/entetePrint.png" alt=""/>
    <h2 class="enteteContent">{{ 'contretypage.stepColorMatching' | translate}}</h2>
    <img class="imgImp" src="assets/Impression/peintre.png" alt=""/>
    <div class="accroche"> {{ 'contretypage.accrocheImp' | translate}} </div>
  </div>

  <div class="contentPrint">
    <div class="infoContretypage legendImp">
      <div>{{ 'contretypage.demande' | translate}} : {{colMatching.reference}}</div>
      <div>
        {{ 'common.manufacturer' | translate}} :
        <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showBrandRep else showBrandReq"></span>
        <ng-template #showBrandRep>{{ colMatching.response.brandVehicle }}</ng-template>
        <ng-template #showBrandReq>{{ colMatching.brandVehicle }}</ng-template>
      </div>
      <div>
        {{ 'details.code' | translate}} :
        <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showCodeRep else showCodeReq"></span>
        <ng-template #showCodeRep>{{ colMatching.response.codeFormule }}</ng-template>
        <ng-template #showCodeReq>{{ colMatching.codePainting }}</ng-template>
      </div>
      <div>
        {{ 'common.designation' | translate}} :
        <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showDesFormRep else showDesFormReq"></span>
        <ng-template #showDesFormRep>{{ colMatching.response.designationPainting }}</ng-template>
        <ng-template #showDesFormReq>{{ colMatching.designationPainting }}</ng-template>
      </div>
      <div>
        {{ 'contretypage.variante' | translate}} :
        <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showVarFormRep else notShow"></span>
        <ng-template #showVarFormRep>{{ colMatching.response.variante }}</ng-template>
      </div>
      <div>
        {{ 'monitoring.date' | translate}} :
        <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showDateImp else notShow"></span>
        <ng-template #showDateImp> {{ colMatching.dateFinish | date:"dd/MM/yyyy" }}</ng-template>
      </div>
      <p>
        {{ 'common.technology' | translate}} :
        <span *ngIf="techDemande != undefined; then showTechnoImp else notShow"></span>
        <ng-template #showTechnoImp> {{ techDemande }} (0)</ng-template>
      </p>
    </div>
    <div *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish)" class="qrCodeContretypage">
      <div>
        <img class="thumbnail" src="data:image/png;base64,{{qrcode}}" alt=""/>
      </div>
    </div>
    <div *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish)" class="legendImp">

      <div class="breakPage">
        {{ 'contretypage.ingrForm' | translate}} (0) :
        <table class="table lstIngrCM">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">{{ 'contretypage.numero' | translate}}</th>
              <th scope="col">{{ 'details.code' | translate}}</th>
              <th scope="col">{{ 'common.designation' | translate}} </th>
              <th scope="col">{{ 'contretypage.qte' | translate}}</th>
              <th scope="col">{{ 'contretypage.cumul' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of colMatching.response.ingredients">
              <td>{{ element.position }}</td>
              <td>{{ element.code }}</td>
              <td>{{ element.name }}</td>
              <td>{{ element.quantity }}</td>
              <td>{{ element.qtyCumule }}</td>
            </tr>
          </tbody>

        </table>
      </div>

      <div *ngIf="colMatching.response != undefined && colMatching.response.responseMulti != undefined && compareDate(colMatching.dateFinish)">
        <div *ngFor="let multi of colMatching.response.responseMulti; let index = index;" class="breakPageAlways">
          <div class="infoContretypage legendImp">
            <div>{{ 'contretypage.demande' | translate}} : {{colMatching.reference}}</div>
            <div>
              {{ 'common.manufacturer' | translate}} :
              <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showBrandRep else showBrandReq"></span>
              <ng-template #showBrandRep>{{ colMatching.response.brandVehicle }}</ng-template>
              <ng-template #showBrandReq>{{ colMatching.brandVehicle }}</ng-template>
            </div>
            <div>
              {{ 'details.code' | translate}} :
              <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showCodeRep else showCodeReq"></span>
              <ng-template #showCodeRep>{{ colMatching.response.codeFormule }}</ng-template>
              <ng-template #showCodeReq>{{ colMatching.codePainting }}</ng-template>
            </div>
            <div>
              {{ 'common.designation' | translate}} :
              <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showDesFormRep else showDesFormReq"></span>
              <ng-template #showDesFormRep>{{ colMatching.response.designationPainting }}</ng-template>
              <ng-template #showDesFormReq>{{ colMatching.designationPainting }}</ng-template>
            </div>
            <div>
              {{ 'contretypage.variante' | translate}} :
              <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showVarFormRep else notShow"></span>
              <ng-template #showVarFormRep>{{ colMatching.response.variante }}</ng-template>
            </div>
            <div>
              {{ 'monitoring.date' | translate}} :
              <span *ngIf="colMatching.response != undefined && compareDate(colMatching.dateFinish); then showDateImp else notShow"></span>
              <ng-template #showDateImp> {{ colMatching.dateFinish | date:"dd/MM/yyyy" }}</ng-template>
            </div>
            <div>
              {{ 'common.technology' | translate}} :

              <span *ngIf="techDemande != undefined; then showTechnoImp else notShow"></span>
              <ng-template #showTechnoImp> {{ techDemande }} ({{ index + 1 }})</ng-template>

            </div>
          </div>

          <div id="qrCodeContretypage-{{index}}" class="qrCodeContretypage">

          </div>

          <div class="infoContretypage vertical-align-bottom">
            {{ 'contretypage.ingrForm' | translate}} ({{ index + 1 }}) :
          </div>

          <table class="table lstIngrCM">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">{{ 'contretypage.numero' | translate}}</th>
                <th scope="col">{{ 'details.code' | translate}}</th>
                <th scope="col">{{ 'common.designation' | translate}} </th>
                <th scope="col">{{ 'contretypage.qte' | translate}}</th>
                <th scope="col">{{ 'contretypage.cumul' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let elementMulti of multi.ingredients">
                <td>{{ elementMulti.position }}</td>
                <td>{{ elementMulti.code }}</td>
                <td>{{ elementMulti.name }}</td>
                <td>{{ elementMulti.quantity }}</td>
                <td>{{ elementMulti.qtyCumule }}</td>
              </tr>
            </tbody>

          </table>

        </div>
      </div>

      <div class="ecartElement">
        {{ 'contretypage.ecart' | translate}} : {{ colMatching.response.legend }}
      </div>
      <!--<div class="flexRow">-->
      <div class="">
        {{ 'contretypage.comment' | translate}} : {{ colMatching.response.comment }}
      </div>
      <div class="">
        {{ 'contretypage.infoForm' | translate}} :

        <ul class="sentencesImp">
          <li *ngFor="let textSentence of textSentencesCM">
            {{ textSentence.text }}
          </li>
        </ul>

      </div>
      <!--</div>-->
      <div class="legendImp">
        <br />
        <div>{{ 'contretypage.legend' | translate}} :</div>
        <div>
          {{ 'contretypage.leg1' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg2' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg3' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg4' | translate}}
        </div>
        <div>
          {{ 'contretypage.etoile1' | translate}}
        </div>
        <div>
          {{ 'contretypage.etoile2' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
